/**
 * Localized LANDINGS loader.
 */
import { LANDINGS as L_NL } from "@/data/landings";

const LOCALES = [
  "en", "de", "fr", "es", "it", "pt", "pl", "sv", "da", "fi", "no",
  "cs", "sk", "hu", "ro", "bg", "el", "et", "lv", "lt", "hr", "sl", "ga",
  "mt", "zh", "ar",
];

const cache = { nl: L_NL };

LOCALES.forEach((lang) => {
  try {
    // eslint-disable-next-line global-require
    const mod = require(`@/data/landings.${lang}.js`);
    cache[lang] = mod.LANDINGS || mod.default || L_NL;
  } catch (e) {
    cache[lang] = L_NL;
  }
});

export function getLandings(localeCode) {
  return cache[localeCode] || L_NL;
}

/**
 * Get a single landing entry, falling back to NL if not translated yet.
 */
export function getLanding(slug, localeCode) {
  const dict = getLandings(localeCode);
  return dict[slug] || L_NL[slug];
}
